<template>
  <div class="data-import-page">
    <!-- 未完成批次提示 -->
    <transition name="slide-fade">
      <div v-if="showUnfinish && batchInfoListUnfinish.length > 0" class="unfinish-bar">
        <div class="unfinish-icon"><i class="el-icon-warning"></i></div>
        <div class="unfinish-content" :class="{ 'is-more': more }">
          <span ref="tooltipCon" class="unfinish-text">
            您有未完成的批次待处理，可点击批次进行下一步操作，
            <template v-for="(unfinish, i) in batchInfoListUnfinish">
              <el-link :key="i" type="primary" class="unfinish-link" @click="toPage(unfinish)">
                [{{ unfinish.batchName }}]
              </el-link>
              <span v-if="i != batchInfoListUnfinish.length - 1">，</span>
            </template>
            。
          </span>
        </div>
        <div class="unfinish-actions">
          <el-link v-if="more && moreList" class="more-link" @click="isMore">
            <i class="el-icon-arrow-down"></i>更多
          </el-link>
          <el-link v-else-if="!more && moreList" class="more-link" @click="isMore">
            <i class="el-icon-arrow-up"></i>收起
          </el-link>
          <i class="el-icon-close close-icon" @click="closeUnfinish"></i>
        </div>
      </div>
    </transition>

    <!-- 批次信息总览 / 配置表单 -->
    <div class="config-card">
      <!-- 折叠后的摘要 -->
      <transition name="fade-slide">
        <div v-show="isshow" class="summary-box">
          <img class="toggle-icon" src="@/assets/img/dataImport/xia-down.png" alt="" @click="shousu" />
          <div class="summary-grid">
            <div class="summary-item">
              <span class="summary-label">批次名称</span>
              <span class="summary-value ellipsis" :title="batchInfoDetail.batchName">{{ batchInfoDetail.batchName }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">工资月份</span>
              <span class="summary-value">{{ batchInfoDetail.wageMonth }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">社保月份</span>
              <span class="summary-value">{{ batchInfoDetail.socMonth }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">税金月份</span>
              <span class="summary-value">{{ batchInfoDetail.taxMonth }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">考勤月份</span>
              <span class="summary-value">{{ batchInfoDetail.attendanceMonth }}</span>
            </div>
            <div v-if="templateInfoList && templateInfoList.length > 1 && formInline.procName != '仅工资条'" class="summary-item">
              <span class="summary-label">工资表模板</span>
              <span class="summary-value ellipsis" style="max-width: 140px" :title="templateName">{{ templateName }}</span>
            </div>
            <div v-if="payGroupDataList && (payGroupDataList.length > 1 || (payGroupDataList.length == 1 && payGroupDataList[0].children && payGroupDataList[0].children.length > 0))" class="summary-item">
              <span class="summary-label">薪酬组</span>
              <span class="summary-value ellipsis" :title="filterStr(formInline.payGroupId, payGroupDataList)">{{ filterStr(formInline.payGroupId, payGroupDataList) }}</span>
            </div>
            <div v-if="isShow" class="summary-item">
              <span class="summary-label">当前生成批次</span>
              <span class="summary-value">{{ step4Info.batchId }}</span>
            </div>
          </div>
        </div>
      </transition>

      <!-- 展开后的配置表单 -->
      <transition name="fade-slide">
        <div v-show="!isshow" class="form-box">
          <div class="section-title">
            <span class="bar"></span>
            批次配置
            <span class="section-sub">完善以下信息后，再进行数据导入</span>
          </div>

          <el-form :inline="true" :model="formInline" :rules="rules" class="config-form" label-width="90px">
            <!-- 第一行：服务组合 / 薪酬组 / 工资表模板 -->
            <div class="form-row">
              <el-form-item label="服务组合" prop="region" v-if="serverGroupList && serverGroupList.length > 1" class="form-item">
                <el-select v-model="formInline.region" @change="selectServerGroup(formInline.region, true)" placeholder="请选择" :disabled="disabled" class="form-control">
                  <el-option v-for="item in serverGroupList" :key="item.id" :label="item.procName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>

              <el-tooltip
                v-if="contentServerGroup && contentServerGroup.length > 0 && (serverGroupList && serverGroupList.length > 1)"
                effect="light"
                :content="contentServerGroup"
                placement="right"
                class="form-tooltip"
              >
                <img v-if="contentServerGroup && contentServerGroup.length > 0 && formInline.procName != '仅工资条'" src="@/assets/img/dataImport/yiwen.png" alt="" />
              </el-tooltip>

              <el-form-item label="薪酬组" v-if="payGroupDataList && (payGroupDataList.length > 1 || (payGroupDataList.length == 1 && payGroupDataList[0].children && payGroupDataList[0].children.length > 0))" class="form-item">
                <ciic-tree-select
                  class="form-control"
                  :multiple="false"
                  :props="defaultGroupProps"
                  :expand="true"
                  :showFilter="false"
                  :disabled="disabled"
                  :options="payGroupDataList"
                  :value="formInline.payGroupId"
                  @getValue="selectGroup"
                  placeholder="请选择上级薪酬组"
                ></ciic-tree-select>
              </el-form-item>

              <el-form-item label="工资表模板" v-if="templateInfoList && templateInfoList.length > 1" class="form-item">
                <el-select v-model="formInline.templateId" @change="selectModel" placeholder="请选择模板" :disabled="disabled" class="form-control">
                  <el-option v-for="item in templateInfoList" :key="item.id" :label="item.templateName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div>

            <!-- 第二行：批次名称 / 工资月份 / 社保月份 / 税金月份 / 考勤月份 -->
            <div class="form-row">
              <el-form-item label="批次名称" prop="batchName" class="form-item">
                <el-input v-model="batchInfoDetail.batchName" :disabled="disabled" placeholder="请输入批次名称" class="form-control"></el-input>
              </el-form-item>
              <el-form-item label="工资月份" prop="wageMonth" class="form-item">
                <el-date-picker class="form-control" v-model="batchInfoDetail.wageMonth" type="month" :disabled="disabled" value-format="yyyy-MM" placeholder="选择工资月份" @blur="getBatchNameNo"></el-date-picker>
              </el-form-item>
              <el-form-item label="社保月份" prop="socMonth" class="form-item">
                <el-date-picker class="form-control" v-model="batchInfoDetail.socMonth" type="month" :disabled="disabled" value-format="yyyy-MM" placeholder="选择社保月份"></el-date-picker>
              </el-form-item>
              <el-form-item label="税金月份" prop="taxMonth" class="form-item">
                <el-date-picker class="form-control" v-model="batchInfoDetail.taxMonth" type="month" :disabled="disabled" value-format="yyyy-MM" :picker-options="pickerOptions" placeholder="选择税金月份"></el-date-picker>
              </el-form-item>
              <el-form-item label="考勤月份" prop="attendanceMonth" v-show="cusId == '4784348128137368385' || cusId == '8a8000da73fca5e6017448c56af80007' || cusId == '9999013147'" class="form-item">
                <el-date-picker class="form-control" v-model="batchInfoDetail.attendanceMonth" type="month" :disabled="disabled" value-format="yyyy-MM" placeholder="选择考勤月份" @blur="getBatchNameNo"></el-date-picker>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </transition>
    </div>

    <!-- Tabs + 步骤条 + 内容 -->
<!--    <div class="tabs">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane name="first">
          <span slot="label" class="tab-label">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="17 8 12 3 7 8" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
            数据导入
          </span>

          <div class="steps">
            <div class="step-item" :class="{ 'is-active': active == 'step1', 'is-done': ['step2', 'step3', 'step4'].indexOf(active) > -1 }">
              <div class="step-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="17 8 12 3 7 8" />
                  <line x1="12" y1="3" x2="12" y2="15" />
                </svg>
              </div>
              <div class="step-text">
                <h3>数据导入</h3>
                <p>收集薪资相关数据并上传</p>
              </div>
            </div>

            <div class="step-item" :class="{ 'is-active': active == 'step2', 'is-done': ['step3', 'step4'].indexOf(active) > -1 }">
              <div class="step-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                </svg>
              </div>
              <div class="step-text">
                <h3>表头匹配</h3>
                <p>匹配上传文件的表头与系统字段</p>
              </div>
            </div>

            <div class="step-item" :class="{ 'is-active': active == 'step3', 'is-done': ['step4'].indexOf(active) > -1 }">
              <div class="step-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="9 11 12 14 22 4" />
                  <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
                </svg>
              </div>
              <div class="step-text">
                <h3>数据校验</h3>
                <p>校验上传数据并反馈错误信息</p>
              </div>
            </div>

            <div class="step-item" :class="{ 'is-active': active == 'step4' }">
              <div class="step-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <div class="step-text">
                <h3>导入完成</h3>
                <p>导入完成并计算上传雇员的薪资数据</p>
              </div>
            </div>
          </div>

          <div class="line"></div>

          <keep-alive exclude="step2,step3">
            <component
              v-bind:is="active"
              :operation="operation"
              :sheetNameParam.sync="sheetNameParam"
              :headerRow.sync="headerRow"
              :step4Info="step4Info"
              :step3Info.sync="step3Info"
              :batchInfoDetail="batchInfoDetail"
              :formInline.sync="formInline"
              :payGroupId.sync="formInline.payGroupId"
              :orgId.sync="formInline.orgId"
              :step.sync="active"
              style="width: 100%"
              :templateId.sync="formInline.templateId"
              :disabled.sync="disabled"
              :batchName="batchInfoDetail.batchName"
            ></component>
          </keep-alive>
        </el-tab-pane>

        <el-tab-pane name="second">
          <span slot="label" class="tab-label">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 3v5h5" />
              <path d="M3.05 13A9 9 0 1 0 6 5.3L3 8" />
              <polyline points="12 7 12 12 15 15" />
            </svg>
            复制历史数据
          </span>
          <keep-alive exclude="dataHistory">
            <dataHistory ref="dataHistory" :formInline="formInline" :batchInfoDetail="batchInfoDetail"></dataHistory>
          </keep-alive>
        </el-tab-pane>
      </el-tabs>
    </div>-->
    <!-- Tabs + 步骤条 + 内容 -->
    <div class="tabs">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane name="first">
          <span slot="label" class="tab-label">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="17 8 12 3 7 8" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
            数据导入
          </span>

          <!-- 紧凑步骤条：横向胶囊 -->
          <div class="steps">
            <div class="step-item" :class="{ 'is-active': active == 'step1', 'is-done': ['step2', 'step3', 'step4'].indexOf(active) > -1 }">
              <div class="step-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="17 8 12 3 7 8" />
                  <line x1="12" y1="3" x2="12" y2="15" />
                </svg>
              </div>
              <div class="step-text">
                <h3>数据导入</h3>
                <p>收集薪资数据并上传</p>
              </div>
            </div>

            <div class="step-item" :class="{ 'is-active': active == 'step2', 'is-done': ['step3', 'step4'].indexOf(active) > -1 }">
              <div class="step-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                </svg>
              </div>
              <div class="step-text">
                <h3>表头匹配</h3>
                <p>匹配表头与系统字段</p>
              </div>
            </div>

            <div class="step-item" :class="{ 'is-active': active == 'step3', 'is-done': ['step4'].indexOf(active) > -1 }">
              <div class="step-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="9 11 12 14 22 4" />
                  <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
                </svg>
              </div>
              <div class="step-text">
                <h3>数据校验</h3>
                <p>校验数据并反馈错误</p>
              </div>
            </div>

            <div class="step-item" :class="{ 'is-active': active == 'step4' }">
              <div class="step-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <div class="step-text">
                <h3>导入完成</h3>
                <p>计算上传雇员的薪资数据</p>
              </div>
            </div>
          </div>

          <div class="line"></div>

          <keep-alive exclude="step2,step3">
            <component
              v-bind:is="active"
              :operation="operation"
              :sheetNameParam.sync="sheetNameParam"
              :headerRow.sync="headerRow"
              :step4Info="step4Info"
              :step3Info.sync="step3Info"
              :batchInfoDetail="batchInfoDetail"
              :formInline.sync="formInline"
              :payGroupId.sync="formInline.payGroupId"
              :orgId.sync="formInline.orgId"
              :step.sync="active"
              style="width: 100%"
              :templateId.sync="formInline.templateId"
              :disabled.sync="disabled"
              :batchName="batchInfoDetail.batchName"
            ></component>
          </keep-alive>
        </el-tab-pane>

        <el-tab-pane name="second">
          <span slot="label" class="tab-label">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 3v5h5" />
              <path d="M3.05 13A9 9 0 1 0 6 5.3L3 8" />
              <polyline points="12 7 12 12 15 15" />
            </svg>
            复制历史数据
          </span>
          <keep-alive exclude="dataHistory">
            <dataHistory ref="dataHistory" :formInline="formInline" :batchInfoDetail="batchInfoDetail"></dataHistory>
          </keep-alive>
        </el-tab-pane>
      </el-tabs>
  </div>
  </div>
</template>

<script>
import dataHistory from "@/views/wage/dataReadyTemplate/dataImport/template/dataHistory.vue";
import step1 from "@/views/wage/dataReadyTemplate/dataImport/template/step1.vue";
import step2 from "@/views/wage/dataReadyTemplate/dataImport/template/step2.vue";
import step3 from "@/views/wage/dataReadyTemplate/dataImport/template/step3.vue";
import step4 from "@/views/wage/dataReadyTemplate/dataImport/template/step4.vue";
import { commonConst } from "@/const/code";
import { mapGetters } from "vuex";
import {
  getArllTemplateInfos,
  getTemplateInfoListByGroupId,
  getUnfinishBatchInfo,
  checkBatchName
} from "@/api/wage/batchTemplate";
import { queryPmsPayGroupTree } from "@/api/wage/payGroup";
import { orgWageBizProcess } from "@/api/sys/sys";
import { dateByFormat } from "@/filters";
import { getSetRuleByOrgId, getBatchNameNo } from "@/api/wage/companyTemplate";
import CiicTreeSelect from "@/components/ciic/ciic-tree-select/ciic-tree-select";

export default {
  name: "dataImport",
  components: {
    dataHistory,
    step1,
    step2,
    step3,
    step4,
    CiicTreeSelect
  },
  computed: {
    ...mapGetters(["dicts"])
  },
  data() {
    var hasBatchName = (rule, value, callback) => {
      let batchName = this.batchInfoDetail.batchName;
      if (!batchName) {
        return callback(new Error("批次名称不能为空"));
      }
      let param = { batchName: batchName };
      checkBatchName(param).then(res => {
        let i = res.data.data;
        if (i > 0) {
          callback("批次名称不能重复");
          this.$message.warning("批次名称不能重复");
        } else {
          callback();
        }
      });
    };
    var haswageMonth = (rule, value, callback) => {
      if (!this.batchInfoDetail.wageMonth) {
        return callback(new Error("请选择工资月份"));
      }
      callback();
    };
    var hassocMonth = (rule, value, callback) => {
      if (!this.batchInfoDetail.socMonth) {
        return callback(new Error("请选择社保月份"));
      }
      callback();
    };
    var hastaxMonth = (rule, value, callback) => {
      if (!this.batchInfoDetail.taxMonth) {
        return callback(new Error("请选择税金月份"));
      }
      callback();
    };
    return {
      pickerOptions: {
        disabledDate() {
          return false;
        }
      },
      timeOut: false,
      active: "step1",
      firstLoad: true,
      moreList: false,
      more: true,
      isshow: false,
      showUnfinish: true,
      activeName: "first",
      step3Info: {},
      step4Info: {},
      sheetNameParam: "sheet1",
      headerRow: "",
      operation: "92520002",
      contentServerGroup: "",
      disabled: false,
      contentTemplate: "工资表模板必选项",
      templateInfoList: [],
      payGroupDataList: [],
      serverGroupList: [],
      payGroupName: "",
      templateName: "",
      orgId: "",
      cusId: "",
      batchId: "",
      disabledTemplate: true,
      batchInfoListUnfinish: [],
      batchInfoDetail: {
        batchName: "",
        wageMonth: "",
        socMonth: "",
        taxMonth: "",
        attendanceMonth: ""
      },
      isShow: false,
      scrollTop: 0,
      batchInfoDetailRoute: this.$route.query.batchInfoDetail,
      formInlineRoute: this.$route.query.formInline,
      serverGroupListRoute: this.$route.query.serverGroupList,
      contentServerGroupRoute: this.$route.query.contentServerGroup,
      formInline: {
        value1: "",
        region: "",
        payGroupId: "",
        templateId: "",
        orgId: "",
        batchId: "",
        procName: "",
        procNum: "",
        total: "",
        success: "",
        failure: "",
        status: "",
        payWay: "",
        taxTypeList: "",
        input: "",
        isCompute: ""
      },
      defaultGroupProps: {
        children: "children",
        label: "groupName",
        value: "id"
      },
      rules: {
        wageMonth: [{ type: "date", validator: haswageMonth, trigger: "change" }],
        socMonth: [{ type: "date", validator: hassocMonth, trigger: "change" }],
        taxMonth: [{ type: "date", validator: hastaxMonth, trigger: "change" }],
        batchName: [{ validator: hasBatchName, trigger: "blur" }]
      },
      payGroupIdParam: ""
    };
  },
  mounted() {
    document.getElementsByClassName("main")[0].addEventListener("scroll", this.handleScroll, true);
  },
  created() {
    this._queryPmsPayGroupTree();
    this.batchInfoDetail.batchName = dateByFormat(new Date(), "yyyyMM");
    this.batchInfoDetail.taxMonth = dateByFormat(new Date(), "yyyy-MM");
    this._getUnfinishBatchInfo();

    let selectedtemplateId = "youmoban";
    sessionStorage.setItem("selectedtemplateId", JSON.stringify(selectedtemplateId));
  },
  updated() {
    if (!this.$refs.tooltipCon) return;
    let height = this.$refs.tooltipCon.offsetHeight;
    if (height > 66 && this.firstLoad) {
      this.firstLoad = false;
      this.moreList = true;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (["薪资明细"].includes(to.name)) {
      from.meta.keepAlive = true;
    } else {
      from.meta.keepAlive = false;
    }
    next();
  },
  methods: {
    filterStr(val, dict) {
      if (!val) return "";
      let filters = dict.filter(res => {
        if (res.id == val) return res.groupName;
      });
      if (filters[0]) return filters[0].groupName;
    },
    isMore() {
      this.more = !this.more;
    },
    closeUnfinish() {
      this.showUnfinish = false;
    },
    toPage(data) {
      const query = {
        templateId: data.wageTmplId,
        batchId: data.id,
        orgId: data.orgId,
        payGroupId: data.groupId,
        wageMonth: data.wageMonth,
        socMonth: data.socMonth,
        payWay: data.payWay,
        taxMonth: data.taxMonth,
        attendanceMonth: data.attendanceMonth,
        isCompute: data.isCompute,
        regionId: this.formInline.region,
        isHistoryFlag: "false"
      };
      this.$router.push({ path: "/wage/salaryDetailTabs", query });
    },
    _getUnfinishBatchInfo() {
      let params = { isSubmit: commonConst.NO };
      getUnfinishBatchInfo(params).then(res => {
        if (res.data.code == 0) {
          this.batchInfoListUnfinish = res.data.data;
        }
      });
    },
    selectModel(id) {
      const list = this.templateInfoList || [];
      let targetItem = null;
      for (let i = 0; i < list.length; i++) {
        const item2 = list[i];
        const itemId = item2 && item2.id ? item2.id : "";
        if (String(itemId) === String(id)) {
          targetItem = item2;
          break;
        }
      }
      if (!targetItem) {
        this.$message.warning("未找到所选工资表模板");
        return;
      }
      this.templateName = targetItem.templateName;
      this._getSetRuleByOrgId();
      this.$refs.dataHistory._getBatchInfoByGroupId(this.formInline);
    },
    selectGroup({ valueId, valueTitle, name, node }) {
      if (valueId == null) {
        this.templateInfoList = [];
        this.$message.warning("薪酬组已清除,请选择新的薪酬组");
        return;
      }
      this.$set(this.formInline, "payGroupId", valueId);
      let item = this.findPayGroupById(valueId, null);
      this.orgId = item.orgId;
      this.payGroupIdParam = item.id;
      this.$set(this.formInline, "orgId", item.orgId);
      this.$set(this, "payGroupName", valueTitle);

      orgWageBizProcess(item.orgId).then(res => {
        let re = res.data;
        if (re.length > 0) {
          this.serverGroupList = re;
          this.formInline.region = re[0].id;
          this.selectServerGroup(re[0].id, false);
        }
      });

      this.getTemplateInfoListByGroupId(valueId).then(templateName => {
        if (this.payGroupName && templateName) {
          getSetRuleByOrgId(this.payGroupIdParam, this.payGroupName, templateName).then(res => {
            if (res.data.code == 0) {
              this.batchInfoDetail.batchName = res.data.data.batchName;
              this.batchInfoDetail.wageMonth = res.data.data.payMonth;
              this.batchInfoDetail.socMonth = res.data.data.socMonth;
            }
          });
        }
        this.$refs.dataHistory._getBatchInfoByGroupId(this.formInline);
      });
    },
    findPayGroupById(id, tlist) {
      let list = tlist == null ? this.payGroupDataList : tlist;
      for (let i in list) {
        let item = list[i];
        if (item.id == id) {
          return item;
        } else if (item.children && item.children.length > 0) {
          let item1 = this.findPayGroupById(id, item.children);
          if (item1 && item1.id == id) {
            return item1;
          }
        }
      }
    },
    _getSetRuleByOrgId() {
      if (this.payGroupName && this.payGroupName.length > 0) {
        if (this.templateName && this.templateName.length > 0) {
          getSetRuleByOrgId(this.payGroupIdParam, this.payGroupName, this.templateName).then(res => {
            if (res.data.code == 0) {
              this.batchInfoDetail.batchName = res.data.data.batchName;
              this.batchInfoDetail.wageMonth = res.data.data.payMonth;
              this.batchInfoDetail.socMonth = res.data.data.socMonth;
            }
          });
        } else {
          this.$message.warning("该薪酬组无工资表模板数据");
          let selectedtemplateId = "wumoban";
          sessionStorage.setItem("selectedtemplateId", JSON.stringify(selectedtemplateId));
        }
      }
    },
    selectServerGroup(id, flag) {
      let obj = {};
      let str = "";
      obj = this.serverGroupList.find(item => {
        if (item.id == id) {
          if (item.segList == null) {
            this.contentServerGroup = "";
          } else {
            if (item.segList.length > 0) {
              item.segList.forEach(item => {
                if (str.length == 0) {
                  str = item.segName;
                } else {
                  str += ">" + item.segName;
                }
              });
              this.contentServerGroup = str;
            }
            this.$set(this.formInline, "procName", item.procName);
            this.$set(this.formInline, "procNum", item.procNum);

            if (item.procNum != "proc_0010") {
              if (this.templateInfoList[0].id == commonConst.WAGE_TEMPID_ONLY_PAY) {
                this.templateInfoList.splice(0, 1);
                this.formInline.templateId = this.templateInfoList[0].id;
              }
            }

            if (commonConst.WAGE_PROC_SEG_ONGLY_PAY == item.procNum) {
              let obj = this.templateInfoList.find(item => {
                if (item.id == commonConst.WAGE_TEMPID_ONLY_PAY) {
                  return true;
                }
              });
              if (!obj) {
                this.templateInfoList.splice(0, 0, { id: commonConst.WAGE_TEMPID_ONLY_PAY, templateName: "仅工资条默认模板" });
              }
              this.formInline.templateId = commonConst.WAGE_TEMPID_ONLY_PAY;
              this.selectModel(commonConst.WAGE_TEMPID_ONLY_PAY);
            }
          }
        }
      });
      if (flag) {
        this.$refs.dataHistory._getBatchInfoByGroupId(this.formInline);
      }
      this._getUnfinishBatchInfo();
    },
    getTemplateInfoListByGroupId(id) {
      return getTemplateInfoListByGroupId(id).then(res => {
        let rs = res.data;
        if (rs.code == 0) {
          this.templateInfoList = rs.data;
          if (rs.data.length > 0) {
            const hasCurrent = rs.data.some(t => String(t.id) === String(this.formInline.templateId));
            if (!hasCurrent) {
              this.$set(this.formInline, "templateId", rs.data[0].id);
              this.$set(this, "templateName", rs.data[0].templateName);
            }
            return Promise.resolve(rs.data[0].templateName);
          }
        } else {
          this.$message.error("获取模板信息列表失败");
        }
      });
    },
    _queryPmsPayGroupTree() {
      queryPmsPayGroupTree().then(res => {
        let rs = res.data;
        if (rs.code == 0) {
          this.payGroupDataList = rs.data;
          if (this.payGroupDataList.length > 0) {
            this.$set(this.formInline, "payGroupId", rs.data[0].id);
            this.$set(this.formInline, "orgId", rs.data[0].orgId);
            this.orgId = rs.data[0].orgId;
            this.cusId = rs.data[0].cusId;
            this.payGroupIdParam = rs.data[0].id;

            this.getTemplateInfoListByGroupId(rs.data[0].id).then(templateName => {
              if (rs.data[0].groupName.length > 0 && templateName && templateName.length > 0) {
                getSetRuleByOrgId(rs.data[0].id, rs.data[0].groupName, templateName).then(res => {
                  if (res.data.code == 0) {
                    this.batchInfoDetail.batchName = res.data.data.batchName;
                    this.batchInfoDetail.wageMonth = res.data.data.payMonth;
                    this.batchInfoDetail.socMonth = res.data.data.socMonth;
                    this.payGroupName = res.data.data.groupName;
                  }
                });
              }
              this.$refs.dataHistory._getBatchInfoByGroupId(this.formInline);
            });

            orgWageBizProcess(rs.data[0].orgId).then(res => {
              let re = res.data;
              let str = "";
              if (re.length > 0) {
                this.serverGroupList = re;
                this.$set(this.formInline, "region", re[0].id);
                this.$set(this.formInline, "procName", re[0].procName);
                this.selectServerGroup(re[0].id, false);
                if (re[0].segList.length > 0) {
                  re[0].segList.forEach(item => {
                    if (str.length == 0) {
                      str = item.segName;
                    } else {
                      str += ">" + item.segName;
                    }
                  });
                  this.contentServerGroup = str;
                }
              }
            });
          }
        } else {
          this.$message.error("获取薪酬组信息列表失败");
        }
      });
    },
    getTemplateInfoList() {
      getArllTemplateInfos().then(res => {
        let rs = res.data;
        if (rs.code == 0) {
          this.templateInfoList = rs.data;
          if (this.templateInfoList > 0) {
            this.formInline.templateId = this.templateInfoList[0].id;
          }
        } else {
          this.$message.error("获取模板信息列表失败");
        }
      });
    },
    handleClick(tab) {
      this.activeName = tab.name;
      sessionStorage.setItem("activeName", tab.name);
    },
    handleScroll() {
      let batchName = this.batchInfoDetail.batchName;
      let wageMonth = this.batchInfoDetail.wageMonth;
      let socMonth = this.batchInfoDetail.socMonth;
      let taxMonth = this.batchInfoDetail.taxMonth;
      let attendanceMonth = this.batchInfoDetail.attendanceMonth;
      if (!this.timeOut && document.getElementsByClassName("main")[0].scrollTop != this.scrollTop && batchName && wageMonth && socMonth && taxMonth && this.orgId) {
        this.isshow = true;
        this.scrollTop = document.getElementsByClassName("main")[0].scrollTop;
      } else {
        this.isshow = false;
        this.scrollTop = document.getElementsByClassName("main")[0].scrollTop;
      }
    },
    shousu() {
      this.isshow = !this.isshow;
      this.timeOut = true;
      setTimeout(() => {
        this.timeOut = false;
      }, 600);
    },
    activeDiv(i) {
      this.active = i;
    },
    getBatchNameNo() {
      let param = {
        payGroupName: this.payGroupName,
        templateName: this.templateName,
        payMonth: this.batchInfoDetail.wageMonth
      };
      getBatchNameNo(param).then(res => {
        this.batchInfoDetail.batchName = res.data.data;
      });
    }
  }
};
</script>

<style scoped>
.data-import-page {
  padding: 0 20px 24px;
  color: #1D2129;
}

/* ==================== 未完成批次提示 ==================== */
.unfinish-bar {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 18px;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #FFFBEF 0%, #FFF7E0 100%);
  border: 1px solid #F5E3A8;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(210, 192, 97, 0.10);
}
.unfinish-icon {
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFF3D1;
  color: #E6A23C;
  font-size: 16px;
  margin-top: 1px;
}
.unfinish-content {
  flex: 1;
  min-width: 0;
}
.unfinish-content.is-more .unfinish-text {
  max-height: 66px;
  overflow: hidden;
}
.unfinish-text {
  font-size: 13px;
  color: #6B5B2A;
  line-height: 22px;
  display: block;
}
.unfinish-link {
  font-size: 13px !important;
  color: #2F5BFF !important;
  vertical-align: baseline;
}
.unfinish-actions {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 0 0 auto;
}
.more-link {
  font-size: 12px !important;
  color: #2F5BFF !important;
}
.close-icon {
  font-size: 14px;
  color: #B7A86A;
  cursor: pointer;
  transition: color .2s;
}
.close-icon:hover {
  color: #E6A23C;
}

/* ==================== 批次配置卡片 ==================== */
.config-card {
  position: relative;
  background: #fff;
  border: 1px solid #EDF0F5;
  border-radius: 12px;
  padding: 10px 12px 12px;
  box-shadow: 0 2px 12px rgba(29, 33, 41, .04);
  margin-bottom: 20px;
}

/* 折叠摘要 */
.summary-box {
  position: relative;
  padding-right: 40px;
}
.toggle-icon {
  position: absolute;
  top: 2px;
  right: 4px;
  width: 22px;
  height: 22px;
  cursor: pointer;
  opacity: .7;
  transition: opacity .2s;
}
.toggle-icon:hover {
  opacity: 1;
}
.summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 12px 24px;
}
.summary-item {
  display: flex;
  align-items: center;
  min-width: 0;
}
.summary-label {
  flex: 0 0 auto;
  font-size: 13px;
  font-weight: 500;
  color: #4E5969;
  margin-right: 10px;
}
.summary-label::after {
  content: "：";
}
.summary-value {
  font-size: 13px;
  color: #1D2129;
  min-width: 0;
}
.ellipsis {
  display: inline-block;
  max-width: 160px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: middle;
}

/* 展开表单 */
.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 18px;
}
.section-title .bar {
  width: 3px;
  height: 15px;
  border-radius: 2px;
  background: linear-gradient(180deg, #2F5BFF 0%, #7AA1FF 100%);
}
.section-sub {
  font-size: 12px;
  font-weight: 400;
  color: #A9AEB8;
  margin-left: 4px;
}
.form-box {
  position: relative;
}
.config-form >>> .el-form-item {
  margin-bottom: 16px;
  margin-right: 20px;
}
.config-form >>> .el-form-item__label {
  font-size: 13px;
  font-weight: 500;
  color: #4E5969;
}
.form-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
.form-item {
  margin-right: 20px;
}
.form-control {
  width: 230px;
}
.form-control >>> .el-input__inner {
  border-radius: 8px;
}
.form-control.el-date-editor {
  width: 230px;
}
.form-tooltip {
  margin: 6px 20px 0 0;
}
.form-tooltip img {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

/* ==================== Tabs ==================== */
.tabs {
  margin-top: 10px;
}
.tabs >>> .el-tabs__header {
  margin: 0;
  border-bottom: none;
}
.tabs >>> .el-tabs__nav-wrap {
  padding-left: 20px;
}
.tabs >>> .el-tabs__nav {
  border: none !important;
  border-radius: 0;
}
.tabs >>> .el-tabs__item {
  height: 38px;
  line-height: 38px;
  padding: 0 26px !important;
  margin-right: 6px;
  font-size: 14px;
  font-weight: 400;
  color: #4E5969;
  background: #F5F6F8;
  border: 1px solid transparent !important;
  border-bottom: none !important;
  border-radius: 10px 10px 0 0 !important;
  transition: background .25s ease, color .25s ease;
  position: relative;
  left: 0;
}
.tabs >>> .el-tabs__item + .el-tabs__item {
  border-left: none !important;
}
.tabs >>> .el-tabs__item:hover {
  color: #2F5BFF;
  background: #EEF2F8;
}
.tabs >>> .el-tabs__item.is-active {
  color: #2F5BFF;
  background: #FFFFFF;
  font-weight: 600;
  border-color: #E9EDF5 !important;
  border-bottom-color: #FFFFFF !important;
  box-shadow: 0 -3px 12px rgba(66, 106, 198, 0.07);
}
.tabs >>> .el-tabs__item.is-active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 18px;
  right: 18px;
  height: 3px;
  border-radius: 0 0 3px 3px;
  background: linear-gradient(90deg, #5B8CFF 0%, #2F5BFF 100%);
}
.tabs >>> .el-tabs__content {
  background: #FFFFFF;
  border: 1px solid #E9EDF5;
  border-radius: 0 12px 12px 12px;
  box-shadow: 0 4px 20px rgba(66, 106, 198, 0.07);
  padding: 20px;
}
.tab-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.tab-label svg {
  width: 16px;
  height: 16px;
}

/* ==================== 步骤条 ==================== */
.steps {
  display: flex;
  max-width: 1100px;
  margin: 0 auto;
  padding: 16px 30px 10px;
  background: linear-gradient(180deg, #F7FAFF 0%, #FFFFFF 70%);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(66, 106, 198, 0.08);
  position: relative;
}
.steps .step-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  padding: 0 12px;
}
.steps .step-item::after {
  content: '';
  position: absolute;
  top: 29px;
  left: calc(50% + 38px);
  width: calc(100% - 76px);
  height: 2px;
  background: #E2E9F6;
  border-radius: 2px;
  z-index: 0;
  transition: background .3s ease;
}
.steps .step-item.is-done::after {
  background: linear-gradient(90deg, #7FA3FF 0%, #B9CCFF 100%);
}
.steps .step-item:last-child::after {
  display: none;
}
.step-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #FFFFFF;
  border: 2px solid #E2E9F6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #B4C0DA;
  margin-bottom: 16px;
  position: relative;
  z-index: 1;
  transition: all .35s cubic-bezier(.4, 0, .2, 1);
  box-shadow: 0 2px 10px rgba(66, 106, 198, 0.06);
}
.step-icon svg {
  width: 26px;
  height: 26px;
  transition: transform .35s ease;
}
.step-item.is-done .step-icon {
  background: linear-gradient(135deg, #EEF3FF 0%, #DDE7FF 100%);
  border-color: #C4D4FF;
  color: #4C7BFF;
}
.step-item.is-active .step-icon {
  background: linear-gradient(135deg, #5B8CFF 0%, #2F5BFF 100%);
  border-color: transparent;
  color: #FFFFFF;
  box-shadow: 0 8px 22px rgba(64, 108, 255, 0.35);
  transform: scale(1.08);
}
.step-item.is-active .step-icon::after {
  content: '';
  position: absolute;
  top: -6px;
  left: -6px;
  right: -6px;
  bottom: -6px;
  border-radius: 50%;
  border: 2px solid rgba(91, 140, 255, 0.4);
  animation: stepPulse 2s ease-out infinite;
  pointer-events: none;
}
@keyframes stepPulse {
  0% {
    transform: scale(0.92);
    opacity: 1;
  }
  100% {
    transform: scale(1.35);
    opacity: 0;
  }
}
.steps .step-item:hover .step-icon {
  box-shadow: 0 6px 18px rgba(66, 106, 198, 0.14);
}
.step-text h3 {
  font-size: 14px;
  font-weight: 600;
  color: #B4C0DA;
  margin: 0 0 6px;
  line-height: 20px;
  transition: color .3s;
}
.step-text p {
  font-size: 12px;
  color: #B7C3DA;
  margin: 0;
  line-height: 1.6;
  max-width: 180px;
  transition: color .3s;
}
.step-item.is-done .step-text h3 {
  color: #3D6BE8;
}
.step-item.is-done .step-text p {
  color: #8C9DC4;
}
.step-item.is-active .step-text h3 {
  color: #2F5BFF;
  font-weight: 700;
}
.step-item.is-active .step-text p {
  color: #6E80A8;
}
.line {
  height: 1px;
  width: calc(100% - 96px);
  margin: 20px auto;
  background: linear-gradient(90deg, rgba(226, 233, 246, 0) 0%, #E2E9F6 15%, #E2E9F6 85%, rgba(226, 233, 246, 0) 100%);
  border-radius: 2px;
}

/* ==================== 过渡 ==================== */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all .3s ease;
}
.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
.slide-fade-enter-active {
  transition: all .4s ease;
}
.slide-fade-enter {
  transform: translateY(-12px);
  opacity: 0;
}

/* ==================== 小屏适配 ==================== */
@media (max-width: 768px) {
  .config-card {
    padding: 16px;
  }
  .summary-grid {
    grid-template-columns: 1fr;
  }
  .form-control,
  .form-control.el-date-editor {
    width: 100%;
  }
  .form-item {
    width: 100%;
    margin-right: 0;
  }
  .steps {
    flex-direction: column;
    gap: 24px;
    padding: 24px;
  }
  .steps .step-item::after {
    display: none;
  }
}
</style>
